import { useSelector } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {
  loggedUserSelector,
  targetUserSelector,
} from '../../../../redux/context/selectors';
import { DATA_SOURCE_TYPE } from '../../../PatientHealthboard/constants';

export const useSafeDataSourceTitle = (isNotShowName = false) => {
  const loggedUser = useSelector(loggedUserSelector);
  const targetUser = useSelector(targetUserSelector);
  const isMeNotTargetUser =
    !isNotShowName && loggedUser.id !== targetUser.id && !isEmpty(targetUser);
  const name = get(targetUser, 'firstName', '');
  const concatWithName = device => {
    if (isMeNotTargetUser) {
      return `${name}'s ${device}`;
    }
    return device;
  };

  const getSafeDataSourceTitle = (
    dataSourceType,
    formatMessage,
    mainUser,
    arDevicesTitle,
    stepsOrDistance = false,
  ) => {
    if (stepsOrDistance) {
      return mainUser
        ? formatMessage({ id: 'patient.healthboard.myDevices' })
        : `${arDevicesTitle}’s ${formatMessage({
            id: 'patient.healthboard.devices',
          })}`;
    }

    switch (dataSourceType) {
      case DATA_SOURCE_TYPE.DEVICES: {
        return mainUser
          ? formatMessage({ id: 'patient.healthboard.myDevices' })
          : `${arDevicesTitle}’s ${formatMessage({
              id: 'patient.healthboard.devices',
            })}`;
      }
      case DATA_SOURCE_TYPE.CCD: {
        return formatMessage({ id: 'patient.healthboard.ccd' });
      }
      case DATA_SOURCE_TYPE.ALL_SOURCES: {
        return formatMessage({ id: 'patient.healthboard.allSources' });
      }
      case DATA_SOURCE_TYPE.LOCAL: {
        return formatMessage({ id: 'patient.healthboard.local' });
      }
      case DATA_SOURCE_TYPE.FITBIT: {
        return concatWithName(
          formatMessage({ id: 'patient.healthboard.fitBit' }),
        );
      }
      case DATA_SOURCE_TYPE.APPLE: {
        return concatWithName(
          formatMessage({ id: 'patient.healthboard.apple' }),
        );
      }
      case DATA_SOURCE_TYPE.WITHINGS: {
        return concatWithName(
          formatMessage({ id: 'patient.healthboard.withings' }),
        );
      }
      case DATA_SOURCE_TYPE.GOOGLE_FIT: {
        return concatWithName(
          formatMessage({ id: 'patient.healthboard.googleFit' }),
        );
      }
      case DATA_SOURCE_TYPE.TENOVI: {
        return concatWithName(
          formatMessage({ id: 'patient.healthboard.tenovi' }),
        );
      }
      case DATA_SOURCE_TYPE.I_HEALTH: {
        return concatWithName(
          formatMessage({ id: 'patient.healthboard.iHealth' }),
        );
      }
      default:
        return '';
    }
  };

  return { getSafeDataSourceTitle };
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/hooks/useSafeDataSourceTitle.js